import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/business-team-alerts';

function unwrap(body) {
  if (body?.success === false) {
    const msg = body?.message;
    throw new Error(typeof msg === 'string' ? msg : 'Request failed');
  }
  return body?.data ?? body;
}

const businessTeamAlertService = {
  list: async () => {
    const response = await apiClient.get(BASE);
    const data = unwrap(response.data);
    return data?.alerts ?? [];
  },

  create: async (payload) => {
    const response = await apiClient.post(BASE, payload);
    return response.data;
  },

  update: async (uuid, payload) => {
    const response = await apiClient.patch(`${BASE}/${uuid}`, payload);
    return response.data;
  },

  remove: async (uuid) => {
    const response = await apiClient.delete(`${BASE}/${uuid}`);
    return response.data;
  },
};

export default businessTeamAlertService;
